export class PostponeQueue {
    promise: Promise<any> | undefined = undefined;

    async execute(fnc: () => void) {
        return await (async () => {
            await this.promise;
            return fnc();
        })();
    }

    postpone(promise: Promise<any>) {
        console.log("postponing");
        if (this.promise == null) {
            this.promise = promise;
        } else {
            const oldPromise = this.promise;

            this.promise = (async function () {
                await oldPromise;
                await promise;
                return null as any;
            })();
        }
    }
}
export function createPostponeQueue() {
    return new PostponeQueue();
}
